<template>
    <v-menu
        :close-on-click="false"
        :close-on-content-click="false"
        content-class="account-dropdown"
        fixed
        nudge-bottom="5"
        offset-y
        v-model="accountDropdown"
        :attach="attach"
    >
        <template slot="activator">
            <v-btn
                class="account-dropdown-toggle"
                :class="buttonClass"
                :color="iconColor"
                @click.stop="!loggedOutUrl || isUserLoggedIn ? accountDropdown = !accountDropdown : null"
                :flat="isLoginBtnFlat"
                :icon="icon"
                :to="!isUserLoggedIn && loggedOutUrl ? loggedOutUrl : undefined"
            >
                <template v-if="iconPosition === 'start'">
                    <v-icon v-if="showLoggedInIcon && isUserLoggedIn" class="logged-in">{{ accountIcon }}</v-icon>
                    <v-icon v-else-if="showLoggedOutIcon" class="logged-out">{{ accountIcon }}</v-icon>
                    <span class="css-arrow"></span>
                </template>

                <span v-if="!isUserLoggedIn && loggedOutLabel" class="button-label">{{ loggedOutLabel }}</span>
                <span v-if="isUserLoggedIn && loggedInLabel" class="button-label">{{ loggedInLabel }}</span>

                <template v-if="iconPosition === 'end'">
                    <v-icon v-if="showLoggedInIcon && isUserLoggedIn" class="logged-in">{{ accountIcon }}</v-icon>
                    <v-icon v-else-if="showLoggedOutIcon" class="logged-out">{{ accountIcon }}</v-icon>
                    <span class="css-arrow"></span>
                </template>
            </v-btn>
        </template>

        <v-card v-if="isUserLoggedIn" class="text-xs-center" :class="{'logged-in': isUserLoggedIn}">
            <v-card-title class="pa-1">
                <v-spacer></v-spacer>
                <v-btn
                    class="ma-0"
                    @click.stop="accountDropdown = !accountDropdown"
                    flat
                    icon
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p v-if="loggedInWindowLabel" :class="loggedInWindowLabelClassName"
                   v-html="$language.translate(loggedInWindowLabel)"></p>
                <p v-else-if="customerData.firstName" :class="loggedInWindowLabelClassName">
                    {{ customerData.firstName }}'s Konto</p>
                <p v-else :class="loggedInWindowLabelClassName">{{ 'My account' | translation }}</p>
                <v-btn
                    block
                    color="primary"
                    dark
                    large
                    to="/customer/wishlist"
                >
                    {{ 'Wishlist' | translation }}
                </v-btn>
                <v-btn
                    block
                    color="primary"
                    dark
                    large
                    to="/customer/orders"
                >
                    {{ 'Orders' | translation }}
                </v-btn>
                <v-divider class="my-3"></v-divider>
                <a
                    class="text-large"
                    href="#"
                    @click.prevent="logout()"
                >
                    {{ 'Logout' | translation }}
                </a>
            </v-card-text>
        </v-card>

        <v-card v-else class="text-xs-center">
            <v-card-title class="pa-1">
                <v-spacer></v-spacer>
                <v-btn
                    class="ma-0"
                    @click.stop="accountDropdown = !accountDropdown"
                    flat
                    icon
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <login-form v-bind="loginFormConfig"></login-form>

            <v-card-text>
                <v-divider class="mb-3"></v-divider>
                <p :class="registrationLabelClassName">{{ 'Register here' | translation }}</p>
                <p :class="registrationLabelSubtitleClassName">{{ 'New on our webiste?' | translation }}</p>
                <v-btn
                    block
                    color="primary"
                    dark
                    large
                    to="/customer/registration"
                >
                    {{ 'Register now' | translation }}
                </v-btn>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<style>
.account-dropdown {
    position: fixed !important;
}
</style>

<script>
import AccountNavigation from '@breakmedia/prime-vue-customer/src/AccountNavigation';

export default {
    extends: AccountNavigation,
};
</script>
